export var StandardDeviationElementPlacement = /*#__PURE__*/ function(StandardDeviationElementPlacement) {
    /**
   * Where all the action happens. The bar directly under the deviation
   */ StandardDeviationElementPlacement["PrimaryBar"] = "primary-bar";
    /**
   * For now, a purely mobile placement. Below the primary bar.
   */ StandardDeviationElementPlacement["SecondaryBar"] = "secondary-bar";
    /**
   * Collapsed into the primary bar's more actions menu
   */ StandardDeviationElementPlacement["PrimaryBarMenu"] = "primary-bar-menu";
    /**
   * Collapsed into the secondary bar's more actions menu
   */ StandardDeviationElementPlacement["SecondaryBarMenu"] = "secondary-bar-menu";
    /**
   * Completely excluded. Nothing. Nowhere.
   */ StandardDeviationElementPlacement["NotIncluded"] = "not-included";
    return StandardDeviationElementPlacement;
}({});
export const NOT_INCLUDED_VISIBILITY_GROUP = {
    groupPlacement: "not-included",
    countOnBar: 0
};

//# sourceMappingURL=types.js.map